<template>
  <div class="loading">
    <div
      class="loading-wrap"
    >
      <span class="loading-area">
        <img
          src="/static/images/async-loading-spinner.gif"
        >
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Spinner',
  props: {

  },

  methods: {

  },
};
</script>
<style scoped>

.loading {
  display: table;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: transparent;
  /* background: rgba(255,255,255, 0.5); */
  z-index: 10000;
}

.loading .loading-wrap {
  display: table-cell;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  text-align: center;
}

.loading .loading-wrap .loading-area {
  display: flex;
  width: 120px;
  height: 120px;
  margin: auto;
  border-radius: 50%;
  background: #fff;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.1);
}

.loading .loading-wrap .loading-area img {
  width: 100px;
  vertical-align: middle;
}

@media (max-width:768px){
  .loading .loading-wrap .loading-area {width:60px;height:60px}
  .loading .loading-wrap .loading-area img {width:50px}
}

</style>
